import { useParams } from "react-router";
import { Typography, Button, theme } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import PosterCard from "app/components/PosterCard";
import { useGetCompanyQuery } from "api/graphql/queries/company/hooks";
import RecommendationItemCard from "app/components/RecommendationItemCard";
import { ROUTES } from "app/constants/app";

import { CompaniesContainer, CompanyContainer, CompanyHeader } from "./styles";

export default function Company() {
  const { _id } = useParams<WithId>();

  const { data: companyData, loading: loadingCompanyData } = useGetCompanyQuery(
    { variables: { _id } }
  );

  const { mobile, topbarHeight, announcementBarHeight } = useLayout();

  const company = companyData?.getCompany;

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <CompanyContainer>
      {loadingCompanyData ? (
        <p>Cargando tienda...</p>
      ) : (
        <>
          <CompanyHeader headerHeight={headerHeight}>
            <PosterCard
              bgImg={company?.bgImg}
              style={{ height: "50vh", maxHeight: 440 }}
            >
              <Typography as="h1" variant="title1">
                {company?.fantasyName}
              </Typography>

              <Typography
                as="h2"
                variant="paragraph1"
                style={{ color: theme.colorsPalette.white.default }}
              >
                {company?.description}
              </Typography>

              <Button
                as="a"
                href={company?.domain}
                target="_blank"
                variant="secondary"
                style={{
                  width: "fit-content",
                  backgroundColor: "rgb(255 255 255 / 40%)",
                }}
              >
                Visitar tienda
              </Button>
            </PosterCard>
          </CompanyHeader>

          <CompaniesContainer>
            {company?.productCategories.map((category) => (
              <RecommendationItemCard
                key={category._id}
                render="poster"
                item={{
                  type: "productCategory",
                  _id: category._id,
                  internalLink: `${ROUTES.productCategory}/${category._id}`,
                  img: category.image,
                  name: category.name,
                  description: category.description,
                }}
                style={{ card: { height: !mobile ? 232 : 164 } }}
              />
            ))}
          </CompaniesContainer>
        </>
      )}
    </CompanyContainer>
  );
}
